<template>
    <div class="container text-align hero__section">
        <div class="row">
            <div id="projects" class="col-md-10 offset-md-1 text-center">
                <div class="hero__section-inner">
                    <!--<h1>{{ $page->title }}</h1>-->
                    <dropdown ref="dropdown" :selected="selected" placeholder="Filter op status" :options="dropdownOptions" v-on:dropdownChange="changeFilterSelection"></dropdown>
                </div><!-- /.hero__section-inner -->
            </div><!-- /.col-md-12 -->
        </div><!-- /.row -->
    </div><!-- /.container -->
</template>
<script>
    export default{
        props:{
            'selected': {required: false}
        },
        data: function(){
            return {
                dropdownOptions: [
                    { name: 'Alle', value: 'alle' },
                    { name: 'Lopend', value: 'lopend' },
                    { name: 'Toekomstig', value: 'toekomstig' },
                    { name: 'Afgesloten', value: 'afgesloten' },
                ]
            }
        },
        methods: {
            changeFilterSelection: function(object){
                this.$emit('fetchProjects', object.value);
            },
        }
    }
</script>
<style>

</style>